module.exports = __webpack_public_path__ + "img/00016.6e04b5a4.webp";